<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between ">
          <span>REGISTER ACCOUNT</span>
          <v-btn 
            :disabled="loading"
            outlined
            @click="closeDialog"
            class="text-right"
            :x-large="$vuetify.breakpoint.name == 'xl'"
            :large="$vuetify.breakpoint.name == 'lg'"
          >
            <v-icon color="white">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <!--<hr class="info">-->
        <v-card-text>
          <v-row class="mt-3">
            <v-col class="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <v-row>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="loading"
                    label="First name"
                    outlined
                    dense
                    v-model="editUserDto.FirstName"
                    :error-messages="firstNameErrors"
                    required
                    @input="$v.editUserDto.FirstName.$touch()"
                    @blur="$v.editUserDto.FirstName.$touch()"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="loading"
                    label="Last name"
                    outlined
                    dense
                    v-model="editUserDto.LastName"
                    :error-messages="lastNameErrors"
                    required
                    @input="$v.editUserDto.LastName.$touch()"
                    @blur="$v.editUserDto.LastName.$touch()"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="loading"
                    label="Login / E-mail"
                    outlined
                    type="email"
                    v-model="editUserDto.Email"
                    :error-messages="emailErrors"
                    required
                    @input="$v.editUserDto.Email.$touch()"
                    @blur="$v.editUserDto.Email.$touch()"
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="loading"
                    label="Phone number"
                    type="phone"
                    outlined
                    dense
                    v-model="editUserDto.UserPhoneNumber"
                    :error-messages="userPhoneNumberErrors"
                    required
                    @input="$v.editUserDto.UserPhoneNumber.$touch()"
                    @blur="$v.editUserDto.UserPhoneNumber.$touch()"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="loading"
                    label="Password"
                    outlined
                    type="password"
                    v-model="firstPassword"
                    :error-messages="firstPasswordErrors"
                    required
                    @input="$v.firstPassword.$touch()"
                    @blur="$v.firstPassword.$touch()"
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="loading"
                    label="Confirm password"
                    outlined
                    type="password"
                    v-model="checkPassword"
                    :error-messages="checkPasswordErrors"
                    required
                    @input="$v.checkPassword.$touch()"
                    @blur="$v.checkPassword.$touch()"
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                  <h4>User Document ID</h4>
                  <v-text-field
                    class="mt-1"
                    :disabled="loading"
                    label="Document number"
                    outlined
                    dense
                    v-model="editUserDto.DocumentData"
                    :error-messages="documentDataErrors"
                    required
                    @input="$v.editUserDto.DocumentData.$touch()"
                    @blur="$v.editUserDto.DocumentData.$touch()"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-center">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="mt-3">
                <v-col class="col-6 d-flex justify-start">
                </v-col>
                <v-col class="col-6 d-flex justify-end">
                  <v-btn :disabled="loading || noDataRegister" depressed outlined 
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'"
                    @click="tryOpenCreateDevice()">
                    Add Object 
                  </v-btn>
                </v-col>
              </v-row>
              <hr class="mt-4 info">
              <v-row no-gutters class="mt-3">
                <v-col class="col-12 d-flex justify-center">
                  <p class="mb-1 mt-2">The account will be registered the first time you connect your device. <a class="color-white" href="https://division.business/product-category/controllers-en/" target="_blank" rel="noopener noreferrer">Open device store</a></p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <CreateDevice :isShowDialog="isCreateDevice" @HideCreateDevice="isCreateDevice = false" :userRegisterData="editUserDto"></CreateDevice>
  </div>
</template>

<script>
  import storageService from "../services/storageService"
  import md5 from 'md5'
  import CreateDevice from './modals/CreateDevice'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import { validationMixin } from 'vuelidate'
  import { required, minLength, email } from 'vuelidate/lib/validators'
  import validationService from '@/services/validationService'
  export default {
    name: 'RegisterAccount',
    mixins: [validationMixin],
    validations: {
      firstPassword: { required, minLength: minLength(6) },
      checkPassword: { required, minLength: minLength(6) },
      editUserDto:{
        FirstName: { required },
        LastName: { required },
        UserPhoneNumber: { required },
        DocumentData: { required },
        Email: { required, email }
      }
    },
    data(){
      return {
        isShowDialog: true,
        isEditUser: false,
        isShowEditPassword: false,
        firstPassword: '',
        checkPassword: '',
        editUserDto: {
          FirstName: '',
          LastName: '',
          UserPhoneNumber: '',
          DocumentData: '',
          Email: '',
          Password: '',
          UserId: 0
        },
        loading: false,
        isCreateDevice: false
      }
    },
    components:{
      CreateDevice
    },
    computed:{
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      },
      firstPasswordErrors () {
        return validationService.passwordErrors(this.$v.firstPassword)
      },
      checkPasswordErrors () {
        return validationService.passwordErrors(this.$v.checkPassword)
      },
      emailErrors () {
        return validationService.emailErrors(this.$v.editUserDto.Email)
      },
      firstNameErrors () {
        return validationService.emailErrors(this.$v.editUserDto.FirstName)
      },
      lastNameErrors () {
        return validationService.emailErrors(this.$v.editUserDto.LastName)
      },
      userPhoneNumberErrors () {
        return validationService.emailErrors(this.$v.editUserDto.UserPhoneNumber)
      },
      documentDataErrors () {
        return validationService.emailErrors(this.$v.editUserDto.DocumentData)
      },
      noDataRegister(){
        let loading = false
        console.log(this.editUserDto)
        if(this.editUserDto.DocumentData.length > 1 && this.editUserDto.FirstName.length > 1 && this.editUserDto.LastName.length > 1 && this.editUserDto.UserPhoneNumber.length > 5 && this.firstPassword.length > 0 && this.checkPassword.length > 0 &&this.firstPasswordErrors == '' && this.checkPasswordErrors == '' && this.emailErrors == ''){
          loading = true
        }
        return !loading
      }
    },
    mounted(){
      /*console.log(this.getUser)
      if(this.getUser){
        this.editUserDto.FirstName = this.getUser.firstName
        this.editUserDto.LastName = this.getUser.lastName
        this.editUserDto.UserPhoneNumber = this.getUser.phone
        this.editUserDto.Email = this.getUser.email
        this.editUserDto.DocumentData = this.getUser.document.number
      }*/
    },
    methods:{
      ...mapActions(['editUser']),
      ...mapMutations(['resetState']),
      closeDialog(){
        this.$root.$emit('loading', 'end')
        this.$router.push('Login').catch(() => {})
      },
      tryOpenCreateDevice(){
        //“Password and Confirm password does not match
        
        if(this.checkPassword== this.firstPassword && this.checkPassword!=null && this.checkPassword!=''){
          this.editUserDto.Password = md5(this.firstPassword)
        }else{
          this.$noty.error(`Password and Confirm password does not match`)
          return
        }
        this.isCreateDevice = true
      },
      editUserHide(){
        this.isEditUser = false
        this.$emit("HideEditUser")
      },
      async saveEditUser(){
        this.loading = true
        this.$root.$emit('loading', "start")
        if(this.isShowEditPassword && this.checkPassword== this.firstPassword && this.checkPassword!=null && this.checkPassword!=''){
          this.editUserDto.Password = md5(this.firstPassword)
        }
        Object.entries(this.editUserDto).forEach(data => {
          if(data[1].length < 2 && data[0] != 'AgregatorId'&&data[0] != 'Password'){
            this.$noty.error(`Check field ${data[0]}`)
            this.loading = false
            this.$root.$emit('loading', "end")
          }
        })
        if(this.isShowEditPassword && this.checkPassword!= this.firstPassword){
          this.$noty.error(`Check field check password`)
          this.loading = false
          this.$root.$emit('loading', "end")
        }
        if(!this.loading){
          return
        }
        
        await this.editUser(this.editUserDto)
        .then(result => {
          this.$noty.success("User has bean edited!")
          this.loading = false
          this.$root.$emit('loading', "end")
          this.$root.$emit("HideisShowUserData")
          storageService.removeAll()
          this.resetState()
          this.$router.push('Login').catch(() => {})
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.code)
          this.$root.$emit('loading', "end")
          this.loading = false
        })
      }
    }
  }
</script>
